// src/utils/api.js
import axios from "axios";

// Centralized API base URL configuration
// In production: uses REACT_APP_API_BASE_URL or falls back to window.location.origin
// This ensures production uses https://beta.bloompal-wellness.com
const getApiBaseURL = () => {
  // Priority 1: Explicit env var (for production: https://beta.bloompal-wellness.com)
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  // Priority 2: Legacy env var (for backward compatibility)
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  // Priority 3: Use current origin (production will be https://beta.bloompal-wellness.com)
  if (typeof window !== "undefined" && window.location) {
    return window.location.origin;
  }
  // Fallback: localhost for dev (shouldn't happen in browser)
  return "http://127.0.0.1:8001";
};

const api = axios.create({
  baseURL: getApiBaseURL(), // Centralized base URL - no /api suffix here
  withCredentials: true,
  xsrfCookieName: "csrftoken",
  xsrfHeaderName: "X-CSRFToken",
  headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" },
});

// CSRF for unsafe methods (you already had this)
const getCookie = (n) => document.cookie.split("; ").find(r => r.startsWith(n + "="))?.split("=")[1];
api.interceptors.request.use(cfg => {
  const m = (cfg.method || "get").toLowerCase();
  if (["post","put","patch","delete"].includes(m)) {
    const t = getCookie("csrftoken"); if (t) cfg.headers["X-CSRFToken"] = t;
  }
  // 🔐 Add auth header if token exists
  try {
    const token = localStorage.getItem("authToken");
    const isAuthed = Boolean(token);
    if (isAuthed && !cfg.headers?.Authorization) {
      cfg.headers = cfg.headers || {};
      cfg.headers.Authorization = `Token ${token}`;
    }

    // Only send guest session id when not authenticated
    if (!isAuthed) {
      const sid = localStorage.getItem('sessionId');
      if (sid) {
        cfg.headers = cfg.headers || {};
        if (!cfg.headers['X-Session-ID']) {
          cfg.headers['X-Session-ID'] = sid;
        }
      }
    } else if (cfg.headers && cfg.headers['X-Session-ID']) {
      delete cfg.headers['X-Session-ID'];
    }
  } catch {}

  return cfg;
});

export default api;
